import type { User } from "~/rocketchat/user/user.entity";
import type { Channel } from "../channel.entity";

import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ChatMessage } from "~/rocketchat/chatMessage/chatMessage.entity";
import { upsertChatMessage } from "~/rocketchat/chatMessage/chatMessageSlice";
import { createThunkName } from "~/rocketchat/redux/createThunkNamespace";
import type { ThunkBase } from "~/rocketchat/redux/types";
import { upsertUserList } from "~/rocketchat/user/userSlice";
import { upsertChannel } from "../channelSlice";

type GetChannelResponseThunkPayload = {
  channel: Channel;
  users: Record<string, User>;
  lastChatMessage: ChatMessage | undefined;
};
export const getChannelResponseThunk = createAsyncThunk<
  void,
  GetChannelResponseThunkPayload,
  ThunkBase
>(
  createThunkName("getChannelResponseThunk"),
  async ({ channel, users, lastChatMessage }, { dispatch }) => {
    dispatch(upsertChannel(channel));
    dispatch(upsertUserList(users));
    if (lastChatMessage) {
      dispatch(upsertChatMessage(lastChatMessage));
    }
  },
);
